// Configuração da API
const getApiUrl = () => {
  // Verificar se estamos em produção baseado no hostname
  const hostname = window.location.hostname;
  // Consideramos produção qualquer domínio web que não seja o ambiente local (localhost/127.0.0.1)
  const isProduction = hostname !== 'localhost' && hostname !== '127.0.0.1';

  console.log('🔧 API URL Detection:');
  console.log('🔧 Hostname:', hostname);
  console.log('🔧 Is Production (not local):', isProduction);
  console.log('🔧 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

  // Usar variável de ambiente se disponível, senão usar detecção automática
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (hostname === 'nostalbeat.com.br' || hostname === 'www.nostalbeat.com.br') {
    return 'https://api.nostalbeat.com.br/api';
  }

  // Em produção ou Docker, utiliza /api (proxy reverso Nginx)
  return '/api';
};

export const API_CONFIG = {
  BASE_URL: getApiUrl(),
  TIMEOUT: 30000, // 30 segundos
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 segundo
};

console.log('🔧 API Config loaded:', API_CONFIG);
